<template>
    <div class="tools row text-center">
        <div v-if="!tools.length">
            </br>没有数据
        </div>
        <div class="first col-xs-3" v-for="(item,index) in tools" :key="item.img" v-if="index < 8">
            <a v-if="index == 3" target="_blank" href="javascript:;">
                <img :src="item.img" />
                <span>{{item.name}}</span>
                <div class="toolspt over-hide">
                    <img :src="item.qr"/>
                </div>
            </a>
            <a v-else-if="index == 5" target="_blank" href="javascript:;">
                <img :src="item.img" />
                <span>{{item.name}}</span>
                <div class="toolspt over-hide">
                    <img :src="item.qr"/>
                </div>
            </a>
            <a v-else-if="index == 7" target="_blank" href="javascript:;" @click="toolsContentShow=true">
                <img :src="item.img" />
                <span>{{item.name}}</span>
            </a>
            <a v-else target="_blank" :href="item.href">
                <img :src="item.img" />
                <span>{{item.name}}</span>
            </a>
        </div>
        <div class="third col-xs-3" v-for="(item,index) in tools" :key="item.img" v-if="index >= 8">
            <a target="_blank" :href="item.href">
                <img :src="item.img" />
                <div>
                    <p>{{item.name}}</p>
                    <p v-html="item.memo"></p>
                </div>
            </a>
        </div>
        <toolsContent :toolsContentShow.sync="toolsContentShow" @clear="toolsContentShow=false"></toolsContent>
    </div>
</template>

<script>
import axios from '../axios'
import toolsContent from './c.game.tools.content'
export default {
    data() {
        return {
            lines: [],
            toolsContentShow:false
        }
    },
    props: ['tools'],
    components:{
        toolsContent
    },
    created() {
        let that = this;
        axios.getLines(function(data) {
            that.lines = data.data.line;
            for (let i = 0; i < that.tools.length && that.lines.length; i++) {
                if (i == 0 || i == 1) {
                    that.tools[i].href = that.lines[0].split('?')[0] + that.tools[i].href
                }
                if (i == 3 || i == 5) {
                    that.tools[i].qr = that.lines[0].split('?')[0] + that.tools[i].qr
                }
            }
        })
    }
}
</script>

<style scoped>
.tools{
    /* overflow: hidden; */
}
.col-xs-3 {
    margin-top: 20px;
    position: relative;
}

.first>a>img {
    width: 256px;
    height: 156px;
    box-shadow: 1px 2px 2px 2px #483d3d;
    border-radius: 10px;
}

.first.col-xs-3>a {
    position: relative;
    display: inline-block;
    transition: all .5s linear;
}

.first.col-xs-3>a>span {
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    line-height: 30px;
    border-radius: 0 0 10px 10px;
    color: #fff;
}

.first.col-xs-3>a:hover {
    transform: scale(1.1, 1.1);
}

.third.col-xs-3 {
    margin-top: 50px;
}

.third.col-xs-3>a>img {
    height: 72px!important;
    width: 72px!important;
    margin-right: 20px;
}

.col-xs-3>a>div {
    display: inline-block;
    text-align: left;
    vertical-align: bottom;
}

.first:nth-child(4)>a>img{
        padding: 10px 40px;
}

a:focus,
a:hover {
    text-decoration: none;
}

.over-hide {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 230px;
    height: 136px;
    background: rgba(80, 80, 80, 0.6);
    border-radius: 10px;
}
.col-xs-3:hover .over-hide{
    opacity: 1;
    cursor: pointer;
}
.over-hide img{
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -55px 0 0 -55px;
    width: 110px;
    border: 3px solid #fff;
}
.toolspt{
    height: 100%;
    width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/c.game.tools.vue